module.exports = __webpack_public_path__ + "img/David-McAdams.2c8cbf5c.jpg";